module.exports = __webpack_public_path__ + "assets/media/star.1b43455e.svg";